import {api} from '../../../system/api';

export default {
    getShippingUsers: (params) => api.get('shipping-users', {...params}),
    getShippingUsersSuggest: (params) => api.get('shipping-users/suggest', {...params})
};
